<ng-template #popoverInviteContent let-data="data">
  <p i18n>Use the following link to join</p>
  <p>{{ data.roomUrl }}</p>
  <p
    ><span i18n class="btn btn-active" target="_blank" (click)="onCopy($event, data.roomUrl); false">Copy link</span></p
  >
</ng-template>

<ng-template #popoverContactSupportContent let-data="data">
  <p i18n>Use the following button to report a problem</p>
  <p
    ><span i18n class="btn btn-active" (click)="onReportProblem(data.roomId, data.roomPid, data.accountIdentity); false"
      >Report problem</span
    ></p
  >
</ng-template>
